import React from 'react';
import {
  Form,
} from '@mairistem/composants';
import { Tiers, TiersIbanList } from '@mairistem/comptabilite';
import { Combobox } from '@mairistem/finances-utils';
import { MODE_REGLEMENT } from '../../../constants/mouvements/modeReglements';

interface TiersFichePanelInformationsBancairesProps {
  tiers: Tiers;
  onChange: any;
}

const TiersFichePanelInformationsBancaires = ({
  tiers,
  onChange,
}: TiersFichePanelInformationsBancairesProps) => {
  const {
    modeReglementDepense = '',
    modeReglementRecette = '',
    ribs = [],
    deletedRibs = [],
    nom,
    prenom,
  } = tiers || {};

  const handleChange = (e, { name, value }) => {
    if (onChange) { onChange({ [name]: value }); }
  };

  return (
    <Form>
      <Form.Group widths="equal">
        <Form.Field
          control={Combobox}
          key="modeReglementDepense"
          label="Mode de règlement en dépense"
          // @ts-expect-error
          placeholder="Mode de règlement en dépense"
          name="modeReglementDepense"
          onChange={handleChange}
          options={MODE_REGLEMENT.DEPENSE_LIST}
          selection
          value={modeReglementDepense}
        />
        <Form.Field
          control={Combobox}
          key="modeReglementRecette"
          label="Mode de règlement en recette"
          // @ts-expect-error
          placeholder="Mode de règlement en recette"
          name="modeReglementRecette"
          onChange={handleChange}
          options={MODE_REGLEMENT.RECETTE_LIST}
          selection
          value={modeReglementRecette}
        />
      </Form.Group>
      <TiersIbanList
        onChange={onChange}
        ribs={ribs}
        deletedRibs={deletedRibs}
        defaultTitulaire={`${nom}${prenom ? ` ${prenom}` : ''}`}
      />
    </Form>
  );
};

export default TiersFichePanelInformationsBancaires;
